import { IEntryLine } from 'types/Draws';

const equalSets = (set1: Set<number | null>, set2: Set<number | null>) => {
  if (set1.size !== set2.size) return false;

  for (const a of set1) if (!set2.has(a)) return false;

  return true;
};

export const shouldShowErrorForNumberChoice = (
  number: number | null,
  max: number
) => {
  if (number === null) return false;

  if (isNaN(number)) return true;
  return number < 1 || number > max;
};

export const entryLineContainsDuplicates = (line: IEntryLine) => {
  return lineContainsDuplicates(line.main.filter((value) => value != null));
};

export const lineContainsDuplicates = (line: (number | null)[]) => {
  const distinctLineNumbers = new Set(line);
  return distinctLineNumbers.size !== line.length;
};

export const validEntries = (
  lines: IEntryLine[],
  numberRanges: number[],
  bonusNumberRanges: number[]
) => {
  for (let i = 0; i < lines.length; i++) {
    if (
      lines[i].main.length !== numberRanges.length ||
      lines[i].bonus.length !== bonusNumberRanges.length
    )
      return false;

    if (entryLineContainsDuplicates(lines[i])) return false;

    for (let j = 0; j < lines[i].main.length; j++) {
      const number = lines[i].main[j];
      if (number === null) {
        return false;
      }
      if (isNaN(number)) return false;
      if (number < 1 || number > numberRanges[j]) return false;
    }

    if (lineHasDuplicates(lines[i], lines)) return false;
  }

  return true;
};

export const lineHasDuplicates = (line: IEntryLine, lines: IEntryLine[]) => {
  const lineElements = new Set(line.main);
  const lineBonusElements = new Set(line.bonus);
  // Check whether this line is duplicated.
  let duplicates = -1; // Start at -1 because we will count 1 for matching the line with itself in the loop below.
  for (let i = 0; i < lines.length; i++) {
    const otherLineElements = new Set(lines[i].main);
    const otherLineBonusElements = new Set(lines[i].bonus);

    if (
      equalSets(lineElements, otherLineElements) &&
      equalSets(lineBonusElements, otherLineBonusElements)
    )
      duplicates++;
  }

  return duplicates > 0;
};
